import data_tematica from "./tematica.json";
const UBIGEO_NACIONAL = '00';
export const DICCIONARIO_TEMATICAS_CODIGO_A_TEXTO = {}

export const LISTA_TEMATICAS = [];
setData();
function setData() {
  if (LISTA_TEMATICAS.length === 0) {
    data_tematica.forEach(item => {
      LISTA_TEMATICAS.push({ value: item.id, label: item.nombre });
      DICCIONARIO_TEMATICAS_CODIGO_A_TEXTO[item.id] = item.nombre;
    });
  }
} 
export function getNombreTematica(codigoTematica) {
    let diccionario = DICCIONARIO_TEMATICAS_CODIGO_A_TEXTO;
    return diccionario[codigoTematica] ? diccionario[codigoTematica] : false;
}
export function getObjectTematica(codigoTematica) {
    let label = getNombreTematica(codigoTematica);
    if (label) {
        return { value: codigoTematica, label }
    }
    return null;
}
/**
 * Lista de indicadores ambientales
 */
const INDICADORES_AMBIENTALES = {};
export const IndicadorAmbiental = {
    /**
     * Obtener indicador ambiental
     * 
     * @param {string} idIndicador 
     * @returns {object}
     */
    get: function (idIndicador) {
        let indicador = INDICADORES_AMBIENTALES[idIndicador];
        if (!indicador) {
            throw new Error(`El ID de indicador #${idIndicador} no existe en INDICADORES_AMBIENTALES`);
        }
        return indicador;
    },
    /**
     * Obtener código de serie
     * 
     * Devuelve el código de serie nacional o regional según sea el caso.
     * 
     * @param {string} idIndicador 
     * @param {string} idUbigeo Id de Region [01-25] o 00 para obtener la serie nacional
     * @returns {number} Código de serie
     */
    getSerie: function (idIndicador, idUbigeo) {
        let indicador = this.get(idIndicador);
        return idUbigeo !== UBIGEO_NACIONAL ? indicador.serieRegional : indicador.serieNacional;
    },
    getNombre(idIndicador) {
        return this.get(idIndicador).nombre;
    },
    getUnidad(idIndicador) {
        return this.get(idIndicador).unidad;
    }
}